import { render } from "./intermediary.configuration.vue?vue&type=template&id=1a3c7634"
import script from "./intermediary.configuration.vue?vue&type=script&lang=js"
export * from "./intermediary.configuration.vue?vue&type=script&lang=js"

import "./intermediary.configuration.vue?vue&type=style&index=0&id=1a3c7634&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__